export default import.meta.ROLLDOWN_FILE_URL_ky0pL7x0cTOKQo35PFl23A